// A small picture of an item: its rendered 3D picture (lib/thumbs: hats,
// robes, faces and heads, on your wizard), or without WebGL the face text on
// a little green screen, or a colour swatch.
import { RARITY_COLORS, type ItemDef } from "@wp/shared";
import { itemThumb } from "../../lib/thumbs";

export function ItemThumb({ item, size = 72 }: { item: ItemDef; size?: number }) {
  const style = { width: size, height: size };
  const src = itemThumb(item.id);
  if (src) return <img className="item-thumb" src={src} width={size} height={size} alt="" aria-hidden="true" />;
  if (item.face) {
    return (
      <span className={`item-thumb face-thumb ${item.face.length > 4 ? "long" : ""}`} style={style} aria-hidden="true">
        {item.face}
      </span>
    );
  }
  return (
    <span
      className="item-thumb swatch-thumb"
      style={{ ...style, background: item.look?.color ?? RARITY_COLORS[item.rarity], borderColor: item.look?.accent ?? RARITY_COLORS[item.rarity] }}
      aria-hidden="true"
    />
  );
}
